import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui";

export default function contentInit() {
    const contentSlider = document.querySelector('.content__slider');

    if (contentSlider !== null) {
        new Swiper(contentSlider, {
            modules: [Navigation, Pagination],
            slidesPerView: 5,
            spaceBetween: 20,
            navigation: {
                nextEl: '.content__navigation--next',
                prevEl: '.content__navigation--prev'
            },
            breakpoints: {
                0: {
                  slidesPerView: 1,
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 3,
                },
                991: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 5,
                },
                1400: {
                    slidesPerView: 5,
                }
            }
        })
    
        Fancybox.bind('[data-fancybox="content-gallery"]', {

        });
    }
}
